import { DisposalSet } from '@neptune/cx/utils';
import { anchoredBoardHref } from './board-anchor';

/** Search only tag choices; the subscription control stays visible. */
export const initTagFilter = (panel: HTMLDetailsElement, gc: DisposalSet) => {
    const search = panel.querySelector<HTMLInputElement>('[data-tag-search]');
    const options = [...panel.querySelectorAll<HTMLAnchorElement>('[data-tag-option]')];
    const empty = panel.querySelector<HTMLElement>('[data-tag-empty]');
    const trigger = panel.querySelector('summary');

    const filter = () => {
        const query = search?.value.trim().toLocaleLowerCase() || '';
        for (const option of options) {
            const name = option.querySelector('[data-tag-name]')?.textContent || '';
            option.hidden = !name.toLocaleLowerCase().includes(query);
        }
        if (empty) empty.hidden = options.some(option => !option.hidden);
    };

    if (search) gc.register(search).addListener('input', filter);
    for (const toggle of panel.querySelectorAll<HTMLInputElement>('[data-filter-toggle]')) {
        gc.register(toggle).addListener('change', () => {
            if (toggle.dataset.href) location.assign(anchoredBoardHref(toggle.dataset.href));
        });
    }
    gc.register(panel).addListener('toggle', () => {
        if (panel.open) {
            if (search) search.value = '';
            filter();
            search?.focus();
        }
    });
    gc.register(panel).addListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            panel.open = false;
            trigger?.focus();
        }
    });
    gc.register(document).addListener('click', (event: MouseEvent) => {
        if (panel.open && !panel.contains(event.target as Node)) panel.open = false;
    });
};
